import moment, { Moment } from 'moment';
import { TFile } from './storage.types';
import {
  TSADocPacketGet,
  TSADocPacketGetUI,
  // TSAPacketForm,
  // TTrainerDocInfo,
} from './animalTraining.types';
import {
  EGender,
  EGenderUi,
  EValueEditingStates,
  TOptionType,
  TOptionTypeUi,
  TEditingBooleanField,
  TEditingField,
  TEditingFieldUi,
  TExpirationDateType,
  TFileDataType,
  TVetRecordTypeUI,
  TFailUI,
  TFail,
  TEditingYesNoFieldUi,
  TYesNoOptionType,
  EVerificationStatus,
  EVerificationStatusUi,
  EAnimalSingleStatusDB,
  EApplicationStatuses,
  EApplicationStatusesUi,
  TCustomOptionTypeUi,
  TCustomSpeciesOptionTypeUi,
  EReproductive,
  EAnimalStatusesUi,
  EAnimalStatuses,
  TPredefinedOptionType,
  EVetRecordVerificationStatus,
  EVetRecordVerificationStatusUi,
} from './generalTypes';
import {
  EHPDocPacketTypesUI,
  TDocPacketGet,
  TDocPacketGetUI,
} from './docPacket.types';

export enum EAnimalTypesUI {
  PET = 'PET',
  ESA = 'ESA',
  SA = 'SA',
}

export enum EAnimalTypes {
  PET = 'PET',
  ESA = 'ESA',
  SA = 'SA',
}

export enum EAuthorizationStatusUI {
  AUTHORIZED = 'Authorized',
  UN_AUTHORIZED = 'Unauthorized',
  NO_STATUS = 'No status',
}
export enum EAuthorizationStatus {
  AUTHORIZED = 'AUTHORIZED',
  UN_AUTHORIZED = 'UN_AUTHORIZED',
  NO_STATUS = 'NO_STATUS',
}

export type TAnimalDetailObjectProps = {
  value: string;
  predefined: boolean;
};

export type TAnimalWeightProps = {
  value: number;
  unit: string;
};

type TUnAuthorizedResidenciesProps = {
  propertyManagementName: string;
  propertyName: string;
};

type TAuthorization = {
  status?: EAuthorizationStatus;
  unAuthorizedResidencies?: TUnAuthorizedResidenciesProps[];
};
export enum EResidencyTypeUI {
  APPLICATION = 'Application',
  RESIDENCY = 'Residency',
}

export enum EResidencyTypeDB {
  APPLICATION = 'APPLICATION',
  RESIDENCY = 'RESIDENCY',
}
export type TConditionalDetailsUI = {
  dueDate: string;
  reason: string;
};
export type TConditionalDetailsDB = {
  dueDate: string;
  reason: string;
};
// PP-10057: what retracted the application; present only when it is retracted. The UI branches on
// ANIMAL_TYPE_NOT_MANAGED, which means the property handles this animal type itself.
export enum EApplicationRetractionSource {
  ANIMAL_TYPE_NOT_MANAGED = 'ANIMAL_TYPE_NOT_MANAGED',
  OTHER = 'OTHER',
}

// PP-10057: why Re-Apply is unavailable, present only when it is. The app explains
// ANIMAL_TYPE_NOT_MANAGED and keeps hiding the action for anything else.
export enum ECanNotReapplyReason {
  ANIMAL_TYPE_NOT_MANAGED = 'ANIMAL_TYPE_NOT_MANAGED',
  OTHER = 'OTHER',
}

export type TAnimalApplicationDataDB = {
  id: string;
  creationTime: string;
  leaseToDate: string | null;
  moveInDate: string;
  status: EApplicationStatuses;
  singleStatus?: EAnimalSingleStatusDB | null;
  inactiveStatusReason: string;
  retractionSource: EApplicationRetractionSource | null;
  requireComplete: boolean;
  canRetract: boolean;
  canMoveOut: boolean;
  canReapply: boolean | null;
  canNotReapplyReason: ECanNotReapplyReason | null;
  reapplyRequireReason: boolean;
  residenceId: string;
  residencyType: EResidencyTypeDB;
  animalResidencyId: string | null;
  conditionalDetails: TConditionalDetailsDB | null;
};

export type TAnimalApplicationDataUI = {
  id: string;
  creationTime: string;
  leaseToDate: string | null;
  moveInDate: string;
  status: EApplicationStatusesUi;
  // What the tenant is shown; status stays for deciding which list the card belongs in.
  displayStatus: EApplicationStatusesUi;
  inactiveStatusReason: string;
  retractionSource: EApplicationRetractionSource | null;
  requireComplete?: boolean;
  canRetract: boolean | null;
  canReapply: boolean | null;
  canNotReapplyReason: ECanNotReapplyReason | null;
  reapplyRequireReason: boolean;
  residenceId: string;
  canMoveOut: boolean | null;
  residencyType: EResidencyTypeUI;
  animalResidencyId?: string;
  conditionalDetails: TConditionalDetailsUI | null;
};

export type TBlockedAction = {
  animalAction: EAnimalActionDB;
  reason: string;
};

export type TBlockedActionUI = {
  animalAction: EAnimalActionUI;
  reason: string;
};

export type TAnimalConversionToPetDB = {
  convertedToPetReason: string | null;
  isConvertedToPet: boolean;
  isConvertedToPetReasonViewed: boolean;
};

export type TAnimalConversionToPetUI = {
  convertedToPetReason: string | null;
  isConvertedToPet: boolean;
  isConvertedToPetReasonViewed: boolean;
};

export type TAnimalPostUI = {
  id: string;
  gender: EGenderUi;
  reproduction: EReproductive | null;
  complete: boolean;
  name?: string;
  profilePicture?: string;
  status?: EAnimalStatusesUi;
  type?: EAnimalTypesUI;
  species?: string;
  speciesPredefined?: boolean;
  breed?: string;
  weight?: TAnimalWeightProps;
  blockedActions: TBlockedActionUI[];
  conversion: TAnimalConversionToPetUI;
  verificationStatus: EVerificationStatusUi;
  hasActiveResidency: EAnimalStatusUponDeletionUI | null;
};

export type TAnimalGet = {
  // residencies: TAnimalApplicationData[];
  id: string;
  gender: EGender;
  isReproductive: boolean | null;
  // authorization?: TAuthorization;  // remove   same fields delete from details
  complete: boolean;
  name?: string;
  profilePicture?: string;
  type?: EAnimalTypes;
  status?: EAnimalStatuses;
  species?: TAnimalDetailObjectProps;
  breed?: TAnimalDetailObjectProps;
  weight?: TAnimalWeightProps;
  // actions?: EAnimalActionDB[]; // remove
  blockedActions: TBlockedAction[];
  conversion: TAnimalConversionToPetDB;
  verificationStatus: EVerificationStatus;
  // statusUponDeletion: EAnimalStatusUponDeletionDB | null; // change to hasActiveResidency
  hasActiveResidency: EAnimalStatusUponDeletionDB | null;
};

export type TGenderUI = { gender: EGenderUi; neutered: TYesNoOptionType };
export type TGender = { type: EGender; isReproductive?: boolean | null };

// PP-10057: one application OPP retracted because the property does not manage the animal's type.
// Carries property + unit because the same type may be managed at the tenant's other residencies.
export type TAnimalTypeRetractionNoticeDB = {
  applicationId: string;
  animalId: string;
  animalName: string | null;
  animalType: EAnimalTypes | null;
  propertyName: string | null;
  unitNumber: string | null;
  message: string | null;
};

export type TAnimalTypeRetractionNoticeUI = {
  applicationId: string;
  animalId: string;
  animalName: string | null;
  animalType: EAnimalTypesUI | null;
  propertyName: string | null;
  unitNumber: string | null;
  message: string | null;
};

// The complete-animal response: it converts the animal to Pet when the tenant says it is not
// required for a disability, which can retract the application where pets are not managed.
export type TAnimalCompleteResultDB = {
  isConvertedToPet: boolean;
  animalTypeRetractionNotices: TAnimalTypeRetractionNoticeDB[] | null;
};

export type TAnimalCompleteResultUI = {
  isConvertedToPet: boolean;
  animalTypeRetractionNotices: TAnimalTypeRetractionNoticeUI[];
};

export type TAnimalTypeChangeResultDB = {
  animalTypeRetractionNotices: TAnimalTypeRetractionNoticeDB[] | null;
};

export type TAnimalTypeChangeResultUI = {
  animalTypeRetractionNotices: TAnimalTypeRetractionNoticeUI[];
};

export type TAnimalCreateReturnedDataDB = {
  animalId: string;
  isConvertedToPet: boolean;
  animalTypeRetractionNotices: TAnimalTypeRetractionNoticeDB[] | null;
};

export type TAnimalCreateReturnedDataUI = {
  id: string;
  isConvertedToPet: boolean;
  // Optional: the complete-animal flow builds this shape itself and cannot produce retractions.
  animalTypeRetractionNotices?: TAnimalTypeRetractionNoticeUI[];
};

export type TAnimalFormDataUI = {
  name: string;
  birthDate: moment.Moment;
  breed: TOptionTypeUi;
  species: TOptionTypeUi;
  primaryColor: TOptionTypeUi;
  secondaryColor1: TOptionTypeUi;
  secondaryColor2: TOptionTypeUi;
  weight: string;
  profilePicture: TFile | null;
  gender: EGenderUi;
  neutered: TYesNoOptionType;
  houseTrained: TYesNoOptionType;
  animalType: EAnimalTypesUI;
  isAggressive: TYesNoOptionType;
  aggressionInfo?: string;
  microchip?: string;
  requiredBecauseOfDisability?: string;
  trainedFor?: string;
  moveInDate?: Moment;
  observableDisability?: boolean;
};

export type TAnimalFormData = {
  animalType: EAnimalTypes;
  name: string;
  birthDate: string;
  species: TOptionType;
  breed?: TOptionType | null;
  primaryColor: TOptionType;
  secondaryColor1: string | null;
  secondaryColor2: string | null;
  weight: string | null;
  profilePicture?: string | null;
  gender: TGender;
  houseTrained?: boolean | null;
  requiredBecauseOfDisability?: string;
  trainedFor?: string;
  aggressiveBehavior: {
    acted?: boolean | null;
    incidentDetails?: string;
    requiredBecauseOfDisability?: string;
    trainedFor?: string;
  };
  microchip?: string | null;
  moveInDate?: string;
  trainedForObservableDisability?: boolean;
};
export type TCreateAnimalIncompleteUI = {
  name: string;
  type: { value: EAnimalTypesUI; label: EAnimalTypesUI };
  species: TOptionTypeUi | null;
  moveInDate: Moment;
  missingNameReason?: string;
  missingTypeReason?: string;
  missingSpeciesReason?: string;
  missingMoveInDateReason?: string;
  tenantResidencyId: string;
};

export type TAnimalIncompleteUI = {
  name: string;
  type: EAnimalTypesUI;
  species: TOptionTypeUi | null;
  id: string;
  applicationId?: string | null;
  moveInDate?: string;
  selected?: boolean;
  hasApplication?: boolean;
  reason?: string;
  animalStatus?: EApplicationStatusesUi | null;
  displayStatus?: EApplicationStatusesUi | null;
};

export type TCreateAnimalIncompleteDB = {
  name: string;
  type: EAnimalTypes;
  species: TOptionType | { id?: string | null; value?: string };
  moveInDate: string;
  missingNameReason?: string;
  missingTypeReason?: string;
  missingSpeciesReason?: string;
  missingMoveInDateReason?: string;
  tenantResidencyId: string;
};
export type TBreedType = TOptionType | TCustomOptionTypeUi;
export type TBreedTypeUi = TOptionTypeUi;

export type TCompleteAnimalFormDataUI = {
  name: string;
  type: TOptionTypeUi;
  birthDate: moment.Moment;
  breed: TBreedTypeUi | null;
  species: TOptionTypeUi;
  primaryColor: TOptionTypeUi;
  secondaryColor1: TOptionTypeUi;
  secondaryColor2: TOptionTypeUi;
  weight: string;
  profilePicture: TFile | string | null;
  gender: EGenderUi;
  neutered: TYesNoOptionType;
  houseTrained: TYesNoOptionType;
  animalId: string;
  isAggressive: TYesNoOptionType;
  aggressionInfo?: string;
  requiredBecauseOfDisability?: string;
  trainedFor?: string;
  microchip?: string;
  observableDisability?: boolean;
};

export type TCompleteAnimalFormData = {
  animalId: string;
  animalType: TOptionTypeUi;
  name: string;
  birthDate: string;
  species: TOptionType | TCustomSpeciesOptionTypeUi;
  breed: TOptionType | TCustomOptionTypeUi | null;
  primaryColor: TOptionType | TCustomOptionTypeUi;
  secondaryColor1: string | null;
  secondaryColor2: string | null;
  weight: string | null;
  profilePicture?: string | null;
  gender?: TGender;
  houseTrained?: boolean | null;
  requiredBecauseOfDisability?: string;
  trainedFor?: string;
  aggressiveBehavior?: { acted?: boolean | null; incidentDetails?: string };
  microchip?: string;
  trainedForObservableDisability?: boolean;
};

export type TAnimalVetRecordsListUi = {
  documentFiles: TFileDataType[];
  id: string;
  canEdit: boolean;
  // status: EVerificationStatusUi;
  vaccinationRecords: TVaccinationRecordUI[];
};

export type TAnimalVetRecordsList = {
  documentFiles: TFileDataType[];
  // expiration: TExpirationDateType;
  id: string;
  // isExpired: boolean;
  // type: TVetRecordType;
  // verificationStatus: EVetRecordVerificationStatus;
  records: TVaccinationRecordDB[];
};

// GET /application/step/uploadable-vet-records returns
// UploadableVetRecordTypesProvider.UploadableVetRecordType records, not bare names.
export type TUploadableVetRecordTypeDB = {
  name: string;
  expirable: boolean;
  predefined: boolean;
};

export type TVaccinationExpirationDB = {
  expirable: boolean;
  date?: string;
  expired: boolean;
};
export type TVaccinationExpirationUI = {
  expirable: boolean;
  date: string;
  expired: boolean;
};

export type TChangedRecordsUI = {
  type: TChangedRecordsTypeDB;
  expiration: TVaccinationExpirationUI;
  id?: string;
};
export type TChangedRecordsDB = {
  type: TChangedRecordsTypeUI;
  expiration: TVaccinationExpirationDB;
  id?: string;
};
export type TChangedRecordsTypeDB = {
  predefined?: string;
  custom?: string;
  value?: string;
};
export type TChangedRecordsTypeUI = {
  predefined?: string;
  custom?: string;
  value?: string;
};

export type TVaccinationRecordDB = {
  type: TVaccinationTypeDB;
  expiration: TVaccinationExpirationDB | null;
  id?: string;
  isExpired?: boolean;
  isLocked?: boolean;
  requiredByVerificationConfiguration?: boolean;
  showTextWhetherDocumentIsRequiredOrNot?: boolean;
  verificationStatus?: EVetRecordVerificationStatus;
};

export type TVaccinationRecordUI = {
  type: TVaccinationTypeUI;
  expiration: TVaccinationExpirationDB | null;
  id?: string;
  isExpired?: boolean;
  requiredByVerificationConfiguration?: boolean;
  showTextWhetherDocumentIsRequiredOrNot?: boolean;
  verificationStatus?: EVetRecordVerificationStatusUi;
  isLocked?: boolean;
};
export type TNewVaccinationRecordDB = {
  type: TChangedRecordsTypeDB;
  expiration: TVaccinationExpirationDB | null;
  id?: string;
  isExpired?: boolean;
};

export type TNewVaccinationRecordUI = {
  type: TChangedRecordsTypeUI;
  expiration: TVaccinationExpirationDB | null;
  id?: string;
  isExpired?: boolean;
};

export type TVaccinationTypeDB = {
  predefined: boolean;
  value: string;
};
export type TVaccinationTypeUI = {
  predefined?: boolean;
  value?: string;
};

export type TAnimalVetRecordCreateUi = {
  animalId: string;
  files: TFile[];
  docName: string;
  records: TVetRecordsUI[];
};

export type TAnimalVetRecordCreate = {
  animalId: string;
  records: TVetRecordsDB[];
  files: TFile[];
  docName: string;
};
export type TVetRecordsDB = {
  type: TVetRecordTypeUI;
  expiration?: TExpirationDateType;
};
export type TVetRecordsUI = {
  type: TVetRecordTypeUI;
  expiration?: TExpirationDateType;
};

export type TConfirmPaymentUi = {
  animalId: string;
  tenantResidencyId: string;
};

export type TConfirmPayment = TConfirmPaymentUi;

export type TVetRecordTypeNameUpdate = {
  animalId: string;
  vetRecordId: string;
  type: TVetRecordTypeUI;
};

export type TVetRecordTypeNameUpdateUI = {
  animalId: string;
  vetRecordId: string;
  type: string;
};

export type TVetRecordExpirationUpdate = {
  animalId: string;
  vetRecordId: string;
  expiration: TExpirationDateType;
};

export type TVetRecordExpirationUpdateUI = {
  animalId: string;
  vetRecordId: string;
  expirationDate: string;
};

export type TConvertAnimalToPetUI = {
  animalId: string;
  // PP-10559: set only by the Assistance Animal Accommodation Policy popup at the end of an
  // ESA/SA application, so the conversion records why the animal became a pet.
  accommodationPolicyNotConfirmed?: boolean;
};

export type TConvertAnimalToPet = {
  animalId: string;
  accommodationPolicyNotConfirmed?: boolean;
};

export type TConvertAnimalToEsaUI = {
  cancelConversionRequest?: boolean;
  animalId: string;
  hasHpDoc?: boolean;
  conversionId?: string;
  requiredBecauseOfDisability: boolean;
  hpDocType?: EHPDocPacketTypesUI;
  // name?: string;
  // emailAddress?: string;
  hpReason?: string;
  // phoneNumber?: string;
  // faxNumber?: string;
  // websites?: string;
  // websiteAdvertised?: string;
  // hpDocPacketLetter?: TFile[];
  // receivedAfterCompletingQuestionnaireOrInterview?: string;
  hpDocumentPacketId?: string;
};

export type TConvertAnimalToEsa = {
  animalId: string;
  conversionId?: string;
  requiredBecauseOfDisability?: boolean;
  // hpDocInfo?: THPDocInfo;
  cancelConversionRequest: boolean | null;
  hpDocMissingReason?: string;
  hpDocumentPacketId?: string;
};

export type TConvertAnimalToSaUI = {
  hasHpDoc?: boolean;
  conversionId?: string;
  // hasTrainerDoc?: boolean;
  animalId: string;
  trainedFor?: string;
  requiredBecauseOfDisability: boolean;
  observableDisability?: boolean;
  hpReason?: string;
  trainerReason?: string;
  cancelConversionRequest?: boolean | null;
  // saDocumentPacketId?: string;
  hpDocumentPacketId?: string;
  // hpDocType?: EHPDocPacketTypesUI;
  // hpDocFormName?: string;
  // hpDocFormEmailAddress?: string;
  // hpDocFormPhoneNumber?: string;
  // hpDocFormFaxNumber?: string;
  // hpDocFormWebsites?: string[];
  // websiteAdvertised?: string;
  // websites?: string;
  // hpDocPacketLetter?: TFile[];
  // receivedAfterCompletingQuestionnaireOrInterview?: string;
};

export type TConvertAnimalToSa = {
  hasHpDoc?: boolean;
  conversionId?: string;
  // hasTrainerDoc?: boolean;
  animalId: string;
  requiredBecauseOfDisability?: boolean;
  trainedFor?: string;
  observableDisability?: boolean;
  hpDocumentInfoNotProvidedReason?: string;
  trainerDocumentInfoNotProvidedReason?: string;
  cancelConversionRequest?: boolean | null;
  // saDocumentPacketId?: string;
  hpDocumentPacketId?: string;
  // hpDocInfo?: THPDocInfo;
  // trainingDocInfo?: TTrainerDocInfo;
};

export type TVetRecordDocumentsDB = {
  animalId: string;
  vetRecordId: string;
  newFiles: TFileDataType[];
  removedDocumentsId: string[];
  removedRecordIds: string[];
  newRecords: TNewVaccinationRecordDB[];
  changedRecords: TNewVaccinationRecordDB[];
};

export type TVetRecordDocumentsUI = {
  animalId: string;
  vetRecordId: string;
  newFiles: TFileDataType[];
  removedDocumentsId: string[];
  removedRecordIds: string[];
  newRecords: TVaccinationRecordUI[];
  changedRecords: TVaccinationRecordUI[];
};
export type TAnimalType = {
  animalId: string;
  newType: EAnimalTypes;
};

export type TAnimalTypeUI = {
  animalId: string;
  type: EAnimalTypesUI;
};

export type TVetRecordUI = {
  animalId: string;
  vetRecordId: string;
};

export type TVetRecord = {
  animalId: string;
  vetRecordId: string;
};

export type TEditingWeightField = {
  value?: number | null;
  unit?: string | null;
  allowedOperations: EValueEditingStates[];
};

export type TEditingWeightFieldUi = {
  value: string | null;
  unit: string | null;
  canEdit: boolean;
  canRemove: boolean;
};
export type TAnimalDetailsGenderField = {
  value: EGender;
  allowedOperations: EValueEditingStates[];
};
export type TAnimalDetailsGenderFieldUi = {
  value: EGenderUi;
  canEdit: boolean;
  canRemove: boolean;
};

export enum EAnimalActionDB {
  DELETE = 'DELETE',
  MOVE_OUT = 'MOVE_OUT',
  CONVERT = 'CONVERT',
}

export enum EAnimalActionUI {
  DELETE = 'DELETE',
  MOVE_OUT = 'MOVE_OUT',
  CONVERT = 'CONVERT',
}

export enum EConvertAnimalStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
}

export enum EConvertAnimalStatusUI {
  APPROVED = 'Converted',
  REJECTED = 'Not approved',
  PENDING = 'Pending',
}

export type TAnimalTypeConversion = {
  createdAt: string;
  trainedFor?: string;
  fromType: EAnimalTypes;
  hpDocumentPacket: TDocPacketGet | null;
  saDocumentPacket: TApplicationSADocPacketGet | null;
  id: string;
  reason: string | null;
  status: EConvertAnimalStatus;
  toType: EAnimalTypes;
  trainerDocumentInfoNotProvidedReason: string | null;
  withdrawnRequest: boolean;
  hpDocumentInfoNotProvidedReason: string | null;
  observableDisability: boolean | null;
};

export type TAnimalTypeConversionUi = {
  createdAt: string;
  trainedFor?: string;
  fromType: EAnimalTypesUI;
  trainerDocumentInfoNotProvidedReason: string | null;
  withdrawnRequest: boolean;
  hpDocumentInfoNotProvidedReason: string | null;
  observableDisability: boolean | null;
  hpDocumentPacket: TDocPacketGetUI | null;
  saDocumentPacket: TApplicationSADocPacketGetUI | null;
  id: string;
  reason: string | null;
  status: EConvertAnimalStatusUI;
  toType: EAnimalTypesUI;
};

export type TAnimalDetails = {
  id: string;
  name: TEditingField;
  profilePicture: TEditingField;
  species: TEditingField;
  breed: TEditingField;
  conversions?: TAnimalTypeConversion[] | null;
  primaryColor: TEditingField;
  secondaryColor1: TEditingField;
  secondaryColor2: TEditingField;
  birthDate: TEditingField;
  weight: TEditingWeightField;
  isHouseTrained: TEditingBooleanField;
  gender: TAnimalDetailsGenderField;
  isReproductive: TEditingBooleanField;
  vetRecords: TAnimalVetRecordsList[] | null;
  saDocumentPackets: TSADocPacketGet[] | null;
  type: EAnimalTypes;
  status?: EVerificationStatus;
  authorization?: TAuthorization;
  actions?: EAnimalActionDB[];
  blockedActions?: TBlockedAction[];
  aggressiveBehavior: TAnimalAggressiveBehaviorDB;
  confirmAggressiveBehavior: boolean;
  hasActiveResidency: EAnimalStatusUponDeletionDB | null;
  microchip: string | null;
  trainedFor?: TEditingField;
  isRequiredBecauseOfDisability?: boolean;
  // PP-10180. Null when the animal is active at none of the tenant's residences.
  tenantResidencyId: string | null;
  trainedForObservableDisability: TEditingBooleanField | null;
  missingSpeciesReason?: string | null;
};

export type TAnimalDetailsUi = {
  id: string;
  name: TEditingFieldUi;
  profilePicture: TEditingFieldUi;
  species: TEditingFieldUi;
  breed: TEditingFieldUi;
  conversions?: TAnimalTypeConversionUi[] | null;
  primaryColor: TEditingFieldUi;
  secondaryColor1: TEditingFieldUi;
  secondaryColor2: TEditingFieldUi;
  birthDate: TEditingFieldUi;
  weight: TEditingWeightFieldUi;
  isHouseTrained: TEditingYesNoFieldUi;
  gender: TAnimalDetailsGenderFieldUi;
  isReproductive: TEditingYesNoFieldUi;
  vetRecordList: TAnimalVetRecordsListUi[];
  packets: TSADocPacketGetUI[];
  type: EAnimalTypesUI;
  status?: EVerificationStatusUi;
  authorizationStatus?: EAuthorizationStatusUI;
  actions?: EAnimalActionUI[];
  blockedActions?: TBlockedActionUI[];
  aggressiveBehavior: TAnimalAggressiveBehaviorUI;
  confirmAggressiveBehavior: boolean;
  hasActiveResidency: EAnimalStatusUponDeletionUI | null;
  trainedFor?: TEditingFieldUi;
  isRequiredBecauseOfDisability?: boolean;
  microchip: string | null;
  tenantResidencyId: string | null;
  trainedForObservableDisability: TEditingYesNoFieldUi | null;
  missingSpeciesReason?: string | null;
};

export type TAnimalDetailsById = {
  name?: TEditingField;
  type?: EAnimalTypes;
  profilePicture?: TEditingField;
  species?: TPredefinedOptionType | null;
  breed?: TPredefinedOptionType | null;
  primaryColor?: TPredefinedOptionType | null;
  secondaryColor1?: TPredefinedOptionType | null;
  secondaryColor2?: TPredefinedOptionType | null;
  birthDate?: TEditingField;
  weight?: TEditingWeightField;
  isHouseTrained?: TEditingBooleanField;
  gender?: TAnimalDetailsGenderField;
  isReproductive?: TEditingBooleanField;
  trainedFor: { value?: string };
  aggressiveBehavior: TAnimalAggressiveBehaviorDB;
  microchip: string | null;
};

export type TAnimalDetailsByIdUi = {
  name?: string | null;
  type?: TOptionTypeUi | null;
  profilePicture?: string | null;
  species?: TOptionTypeUi | null;
  breed?: TOptionTypeUi | null;
  primaryColor?: TOptionTypeUi | null;
  secondaryColor1?: TOptionTypeUi | null;
  secondaryColor2?: TOptionTypeUi | null;
  birthDate?: moment.Moment | null;
  weight?: number | null;
  houseTrained?: string | null;
  gender?: string;
  neutered?: string | null;
  trainedFor: string;
  aggressiveBehavior: TAnimalAggressiveBehaviorUI;
  microchip: string | null;
};

export type TAnimalMetadata = {
  description: string | null;
  hasEsaLetterForAnimal: boolean | null;
  trainedForObservableDisability: boolean | null;
  trainedForObservableDisabilityDescription: string | null;
};

export type TAnimalMetadataUi = {
  description: string | null;
  hasEsaLetterForAnimal: TYesNoOptionType;
  trainedForObservableDisability: TYesNoOptionType;
  trainedForObservableDisabilityDescription: string | null;
};

export type TAnimalFieldUpdateUi = {
  id: string;
  value: string;
};

export type TAnimalCreatableFieldUpdateUi = {
  id: string;
  value: TOptionTypeUi;
};

export type TAnimalCreateFieldUpdateUi = {
  id: string;
  value: string;
};

export type TAnimalNameUpdate = {
  animalId: string;
  name: string;
};
export type TAnimalNameUpdateUi = TAnimalFieldUpdateUi;
export type TAnimalHouseTrainedUpdate = {
  animalId: string;
  houseTrained?: boolean | null;
};
export type TAnimalHouseTrainedUpdateUi = {
  id: string;
  value: TYesNoOptionType;
};
export type TAnimalGenderUpdate = {
  animalId: string;
  gender: EGender;
};
export type TAnimalGenderUpdateUi = {
  id: string;
  value: EGenderUi;
};
export type TAnimalProfileUpdate = {
  animalId: string;
  profilePicture: string;
};
export type TAnimalProfileUpdateUi = TAnimalFieldUpdateUi;
export type TAnimalWeightUpdate = {
  animalId: string;
  weight: string | null;
  unit: string;
};
export type TAnimalWeightUpdateUi = TAnimalFieldUpdateUi;
export type TAnimalTrainedForUpdateUi = TAnimalFieldUpdateUi;
export type TAnimalTrainedForUpdate = {
  animalId: string;
  trainedFor: string;
};
export type TAnimalBirthDate = {
  animalId: string;
  birthDate: string;
};
export type TAnimalBirthDateUi = TAnimalFieldUpdateUi;
export type TAnimalSecondaryColorUpdate = {
  animalId: string;
  colorId: string;
};
export type TAnimalSecondaryColorUpdateUi = TAnimalCreateFieldUpdateUi;
export type TAnimalReproductiveUpdate = {
  animalId: string;
  reproductive?: boolean | null;
};
export type TAnimalReproductiveUpdateUi = {
  id: string;
  value: TYesNoOptionType;
};
export type TAnimalSpeciesUpdate = {
  animalId: string;
  species: TOptionType;
};
export type TAnimalSpeciesUpdateUi = TAnimalCreatableFieldUpdateUi;
export type TAnimalPrimaryColorUpdate = {
  animalId: string;
  primaryColor: TOptionType;
};
export type TAnimalPrimaryColorUpdateUi = TAnimalCreatableFieldUpdateUi;

export type TUpdateAnimalColorsUI = {
  id: string;
  primaryColor?: TOptionTypeUi;
  secondaryColor1?: TOptionTypeUi;
  secondaryColor2?: TOptionTypeUi;
};

export type TUpdateAnimalColors = {
  animalId: string;
  primaryColor?: {
    value?: string;
    id?: string | null;
  };
  secondaryColor1?: string;
  secondaryColor2?: string;
};

export type TAnimalColorsUI = {
  label: string;
  value: string;
  __isNew__: boolean;
};

export type TAnimalColors = {
  value?: string;
  id: string | null;
};
export type TAnimalBreedUpdate = {
  animalId: string;
  breed: TOptionType;
};

export type TAnimalBreedUpdateUi = TAnimalCreatableFieldUpdateUi;

export type TApplicationSADocPacketGetUI = TSADocPacketGetUI & {
  fails: TFailUI[];
};
export type TApplicationSADocPacketGet = TSADocPacketGet & { fails?: TFail };

export type TApplicationVetRecordsUI = TAnimalVetRecordsListUi & {
  fails: TFailUI[];
};
export type TApplicationVetRecords = TAnimalVetRecordsList & {
  fails?: TFail;
};

export type TApplicationAnimalUI = Omit<
  TAnimalDetailsUi,
  'vetRecordList' | 'packets' | 'actions'
> & {
  fails: TFailUI[];
  documentsFails?: TFailUI[];
  vetRecordList: TApplicationVetRecordsUI[];
  packets: TApplicationSADocPacketGetUI[];
};

export type TApplicationAnimal = Omit<
  TAnimalDetails,
  'vetRecords' | 'saDocumentPackets' | 'actions'
> & {
  fails?: TFail;
  docFails: TFailUI[];
  vetRecords: TApplicationVetRecords[] | null;
  saDocumentPackets: TApplicationSADocPacketGet[] | null;
};

export enum EMoveOutOrRetractReasonTypeDB {
  ANIMAL_HAS_PASSED_AWAY = 'ANIMAL_HAS_PASSED_AWAY',
  ANIMAL_HAS_RE_HOMED = 'ANIMAL_HAS_RE_HOMED',
}

export enum EMoveOutOrRetractReasonTypeUI {
  ANIMAL_HAS_PASSED_AWAY = 'My animal has passed away ',
  ANIMAL_HAS_RE_HOMED = 'I have re-homed my animal',
}

export type TMoveOutReasonDB = {
  predefined?: EMoveOutOrRetractReasonTypeDB;
  other?: string;
};

export type TMoveOutReasonUI = {
  predefinedType?: EMoveOutOrRetractReasonTypeUI;
  other?: string;
};

export type TMoveOutFormDB = {
  animalId: string;
  reason: TMoveOutReasonDB;
};

export type TMoveOutFormUI = {
  animalId: string;
  reason: EMoveOutOrRetractReasonTypeUI;
  other: string;
};

export type TMoveOutFromResidencyFormDB = {
  animalIds: string[];
  residencyId: string;
  moveOutReason: TMoveOutReasonDB;
};

export type TMoveOutFromResidencyFormUI = {
  animalIds: string[];
  residencyId: string;
  reason: EMoveOutOrRetractReasonTypeUI;
  other: string;
};

export type TUnAuthorizedResidencyDB = {
  propertyName: string;
  propertyManagementName: string;
  unitNumber: string;
};

export type TUnAuthorizedResidencyUI = {
  propertyName: string;
  propertyManagementName: string;
  unitNumber: string;
};

export type TIncompleteAnimalsDataDB = {
  count: number;
  animalId: string;
  applicationId: string;
  tenantResidencyId: string | null;
  incompleteResource: 'ANIMAL' | 'APPLICATION';
};
export type TIncompleteAnimalsDataUI = {
  count: number;
  animalId: string;
  applicationId: string;
  // Which property's config set governs the fields when the Complete-animal form opens from here.
  tenantResidencyId?: string;
  incompleteResource: 'ANIMAL' | 'APPLICATION';
};

export type TAnimalSpecieDB = {
  value: string;
  predefinedId: string;
  predefined: boolean;
};
export type TAnimalSpecieUI = {
  value: string;
  predefinedId: string;
  predefined: boolean;
};

export type TPotentialDuplicationAnimalsDB = {
  ownerName: string;
  ownerUsername: string;
  animalId: string;
  animalName: string;
  animalType: string;
  animalSpecie: TAnimalSpecieDB | null;
};
export type TPotentialDuplicationAnimalsUI = {
  ownerName: string;
  ownerUsername: string;
  animalId: string;
  animalName: string;
  animalType: string;
  animalSpecie: TAnimalSpecieUI | null;
};

export type TAnimalDuplicationDB = {
  createdAnimalId: string | null;
  failure: string | null;
  potentialDuplicateAnimals: TPotentialDuplicationAnimalsDB[];
  animalTypeRetractionNotices: TAnimalTypeRetractionNoticeDB[] | null;
};
export type TAnimalDuplicationUI = {
  createdAnimalId: string | null;
  failure: string | null;
  potentialDuplicateAnimals: TPotentialDuplicationAnimalsUI[];
  animalTypeRetractionNotices: TAnimalTypeRetractionNoticeUI[];
};

export type TRegisterAnimalUI = {
  animalId?: string;
};

export type TDuplicateCheckDB = {
  animalId: string;
  tenantResidencyId?: string;
};

export type TDuplicateCheckUI = {
  animalId: string;
  residencyId?: string;
};

export type TDuplicationPreventionDB = {
  animalId: string;
  animalName: string;
  animalSpice: string | null;
  animalType: EAnimalTypes;
  ownerName: string;
  ownerUsername: string;
  status: EApplicationStatuses;
};

export type TDuplicationPreventionUI = {
  animalId: string;
  animalName: string;
  animalSpice: string | null;
  animalType: EAnimalTypesUI;
  ownerName: string;
  ownerUsername: string;
  status: EApplicationStatusesUi;
};

export type TAnimalAggressiveBehaviorDB = {
  acted: boolean | null | undefined;
  incidentDetails?: string;
  allowedOperations?: EValueEditingStates[];
};

export type TAnimalAggressiveBehaviorUI = {
  acted: TYesNoOptionType;
  incidentDetails?: string;
  canEdit?: boolean;
  canRemove?: boolean;
  canAdd?: boolean;
};

export type TAnimalAggressionUpdateDB = {
  animalId: string;
  aggressiveBehavior: TAnimalAggressiveBehaviorDB;
};

export type TAnimalAggressionUpdateUI = {
  id: string;
  aggressiveBehavior: TAnimalAggressiveBehaviorUI;
};

export type TAnimalMicrochipDB = {
  animalId: string;
  microchip: string;
};
export type TAnimalMicrochipUI = {
  id: string;
  microchip: string;
};

export type TConfirmAnimalTypeUI = {
  animalId: string;
  toType: string;
};

export enum EAnimalStatusUponDeletionDB {
  RESIDENT = 'RESIDENT',
  APPLICANT = 'APPLICANT',
}

export enum EAnimalStatusUponDeletionUI {
  RESIDENT = 'RESIDENT',
  APPLICANT = 'APPLICANT',
}

export type TConvertedToPetAcknowledgmentDB = {
  convertedToPetReason: string;
  id: string;
  name: string;
  species: TOptionType;
};
export type TConvertedToPetAcknowledgmentUI = {
  convertedToPetReason: string;
  id: string;
  name: string;
  species?: string;
};

export enum EConvertedToPetResolve {
  REQUEST_TO_CONVERT = 'REQUEST_TO_CONVERT',
  UNDERSTOOD = 'UNDERSTOOD',
}

export type TConvertedToPetResolveUI = {
  animalId: string;
  status: EConvertedToPetResolve;
};

export enum EAnimalPaymentStatusDB {
  PAID = 'PAID',
  MISSING = 'MISSING',
  MISSING_RENEWAL = 'MISSING_RENEWAL',
  SCHEDULED_RENEWAL = 'SCHEDULED_RENEWAL',
}

export enum EAnimalPaymentStatusUI {
  PAID = 'Paid',
  MISSING = 'Missing',
  MISSING_RENEWAL = 'Missing-Renewal',
  SCHEDULED_RENEWAL = 'Scheduled-Renewal',
}
